import { ApplicationsPortfolioPropertiesGrid } from '../../components/ApplicationsPortfolioPropertiesGrid';

export const renderPortfolioRecords = (e) => {
    if (!e.data.isPortfolio) {
        return '';
    }
    return (
        <div style={{ padding: '10px 20px' }}>
            <ApplicationsPortfolioPropertiesGrid
                application={e.data}
                data={e.data.properties}
            />
        </div>
    );
};
